import React from "react";

const Blog = () => {
  return (
    <div className="hero min-h-screen bg-gradient-to-r from-slate-200 to-red-200">
      <div className="hero-content text-center">
        <div className="max-w-md">
          <h1 className="text-5xl font-bold">Comming Soon</h1>
        </div>
      </div>
    </div>
  );
};

export default Blog;
